import { LandingLayout } from 'layouts';
import { ContentLeft, Footer, Header, type MobilePlatform, RedirectToMobileApp } from 'features/onboarding';

type P = {
  onContinueInBrowser: () => void;
  platform: MobilePlatform;
};

const PageRedirectToMobileApp = ({ onContinueInBrowser, platform }: P) => (
  <LandingLayout
    contentLeft={<ContentLeft />}
    contentRight={<RedirectToMobileApp onContinueInBrowser={onContinueInBrowser} platform={platform} />}
    footer={<Footer />}
    header={<Header items={[]} />}
  />
);

export default PageRedirectToMobileApp;
